// @flow
import { SPACING } from '@tablekit/theme';

export const MAX_WIDTH = '1600px';
export const Z_INDICES = {
  MODAL: 900,
  MOBILE_NAV: 600,
  NAV: 520,
  HERO_BANNER: 510,
  MAX_CONTENT: 300
};
export const GRID_GUTTER = SPACING.L6;

// Spec says 18px, which isn't in our spacing so L4 (16px) is good enough
export const MOBILE_GUTTER = SPACING.L4;

export const MOBILE_PORTRAIT_MAX_WIDTH = 576;
export const MOBILE_MAX_WIDTH = 813;
export const LAPTOP_MAX_WIDTH = 1024;
export const DESKTOP_MAX_WIDTH = 2065;
export const DESKTOP_BREAKPOINT = `(min-width: ${LAPTOP_MAX_WIDTH + 1}px)`;
export const LAPTOP_BREAKPOINT = `(min-width: ${MOBILE_MAX_WIDTH + 1}px)`;
export const LAPTOP_ONLY_BREAKPOINT = `(min-width: ${
  MOBILE_MAX_WIDTH + 1
}px) and (max-width: ${LAPTOP_MAX_WIDTH}px)`;
export const MOBILE_LANDSCAPE_BREAKPOINT = `(min-width: ${MOBILE_PORTRAIT_MAX_WIDTH}px)`;

// TODO refactor these out to consistently use min-width TSW-799
export const MOBILE_BREAKPOINT = `(max-width: ${MOBILE_MAX_WIDTH}px)`;
export const MOBILE_PORTRAIT_BREAKPOINT = `(max-width: ${MOBILE_PORTRAIT_MAX_WIDTH}px)`;

export const LAZY_LOAD_OFFSET = 500;
